import React, { useEffect } from "react"
import { useStateMachine } from "#/components/context/stateMachine/StateMachineV2"
import { Progress } from "@carrotfertility/carotene-core"
import { useCarrotMatch } from "#/components/carrot-match-fertility-clinic-precision-matching/context/CarrotMatchContext"

export function HasUserGivenFeedbackDecisionStep(): JSX.Element {
  const { send } = useStateMachine(null)
  const { carrotMatchInteraction } = useCarrotMatch()

  useEffect(() => {
    if (carrotMatchInteraction?.matchFeedback && Object.keys(carrotMatchInteraction?.matchFeedback).length > 0) {
      send("YES")
    } else {
      send("NO")
    }
  }, [carrotMatchInteraction, send])

  return <Progress />
}
